export const Frontpage = () => import(/* webpackChunkName: "page/Frontpage" */ '../views/frontpage/pages/frontpage.vue').then((m) => m.default || m);
export const Category = () => import(/* webpackChunkName: "page/Category" */ '../views/category/pages/_id.vue').then((m) => m.default || m);
export const ArticleBase = () => import(/* webpackChunkName: "page/ArticleBase" */ '../views/article/pages/article.vue').then((m) => m.default || m);
export const Article = () => import(/* webpackChunkName: "page/Article" */ '../views/article/pages/_id.vue').then((m) => m.default || m);
export const ArticleComments = () => import(/* webpackChunkName: "page/ArticleComments" */ '../views/comments/pages/comments.vue').then((m) => m.default || m);
export const ArticleCommentsNapo = () =>
  import(/* webpackChunkName: "page/ArticleCommentsNapo" */ '../views/comments/pages/napo.vue').then((m) => m.default || m);
export const Tags = () => import(/* webpackChunkName: "page/Tags" */ '../views/tags/pages/tags.vue').then((m) => m.default || m);
export const Tag = () => import(/* webpackChunkName: "page/Tag" */ '../views/tags/pages/_id.vue').then((m) => m.default || m);
export const Authors = () => import(/* webpackChunkName: "page/Authors" */ '../views/authors/pages/authors.vue').then((m) => m.default || m);
export const Author = () => import(/* webpackChunkName: "page/Author" */ '../views/authors/pages/_id.vue').then((m) => m.default || m);
export const Search = () => import(/* webpackChunkName: "page/Search" */ '../views/search/pages/search.vue').then((m) => m.default || m);
export const Custom = () => import(/* webpackChunkName: "page/custom" */ '../views/custom/pages/custom.vue').then((m) => m.default || m);
export const Latest = () => import(/* webpackChunkName: "page/latest" */ '../views/latest/pages/latest.vue').then((m) => m.default || m);
export const Popular = () => import(/* webpackChunkName: "page/popular" */ '../views/popular/pages/popular.vue').then((m) => m.default || m);
export const Bookmarks = () => import(/* webpackChunkName: "page/popular" */ '../views/bookmarks/pages/bookmarks.vue').then((m) => m.default || m);
export const Weather = () => import(/* webpackChunkName: "page/weather/_id.vue" */ '../views/weather/pages/_id.vue').then((m) => m.default || m);

export const routerComponents = {
  Frontpage,
  Category,
  ArticleBase,
  Article,
  ArticleComments,
  ArticleCommentsNapo,
  Tags,
  Tag,
  Authors,
  Author,
  Search,
  Custom,
  Latest,
  Popular,
  Bookmarks,
  Weather,
};
